export default {
  'beforeYouBegin': {
    header: 'Avant de commencer',
  },
  'byb-step-3': {
    header: 'Renseignements sur la recrue',
    underEighteen: 'Vous n’êtes pas admissible à un DEI en raison de votre date de naissance.',
    contactPresentQuestion:
      'Remplissez-vous ce DEI à l’aide d’un outil de conférence Web tiers (ce qui signifie que vous n’êtes pas présent physiquement avec le demandeur)?',
    contactRecentlyEmployedQuestion: 'La recrue occupe-t-elle actuellement un emploi?',
    contactAffiliateQuestion:
      "Veuillez sélectionner « Oui » si la recrue était représentant(e) auprès de l'une des sociétés affiliées ou sociétés antérieures suivantes: Une société Primerica aux États-Unis ou au Canada, notamment La Compagnie d'Assurance-Vie Primerica du Canada, Les Placements PFSL du Canada Ltée, Les Services Financiers Primerica Ltée, Les Services à la Clientèle Primerica Inc., A. L. Williams, de MILICO, National Benefit Life ou Primerica Financial Services of New York?",
    contactAffiliateSolutionNumber: {
      label: 'Code de représentant',
      error: {
        minlength: 'Le code de représentant doit être composé de 5 caractères',
        pattern: 'Seuls les caractères alphanumériques sont autorisés.',
      },
    },
    webConferencing: 'Voir les directives sur les conférences Web',
    webConfAlert: {
      title: 'Vous êtes sur le point de quitter la Primerica App',
      message:
        "Veuillez noter que vous êtes sur le point d'accéder à POL. Pour quitter ce dernier et retourner à la Primerica App, fermez l'onglet du navigateur.",
    },
  },
  'languages': [
    {
      text: 'Anglais (US)',
      value: 'en-US',
    },
    {
      text: 'Spanish (US)',
      value: 'es-US',
    },
    {
      text: 'Anglais (CA)',
      value: 'en-CA',
    },
    {
      text: 'Français (CA)',
      value: 'fr-CA',
    },
  ],
  'continue': 'Continuer',
  'Back': 'Retour',

  // For onex-ui-lib
  'COMP_YES': 'Oui',
  'COMP_NO': 'Non',
  'COMP_DATE_OF_BIRTH': 'Date de Naissance',
  'L_POL_FIRST_NAME': 'Prénom',
  'L_POL_LAST_NAME': 'Nom de famille',
};
